import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

import { BackofficeBoschDTO } from "../../shared/models/backoffice-bosch-dto";
import { SearchFormDTO } from "../../modules/private/modules/backoffice-bosch/components/models/search-form-dto";
import { EmailDTO } from "src/app/shared/models/email-dto";
import { BackofficeFranchiseDTO } from "@shared/models/backoffice-franchise-dto";
import { PageManager } from "@shared/models/page-manager";
import { PaginatedResponse } from "src/app/modules/private/modules/franchises/models/franchises-response-dto";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class BackofficeBoschService {
  private backofficeBoschUrl = "backoffice-users/";

  constructor(private http: HttpClient) {}

  save(backofficeBoschDTO: BackofficeBoschDTO): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + this.backofficeBoschUrl,
      backofficeBoschDTO
    );
  }

  listAll(): Observable<BackofficeBoschDTO[]> {
    return this.http.get<BackofficeBoschDTO[]>(
      environment.apiUrl + this.backofficeBoschUrl
    );
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(
      environment.apiUrl + `${this.backofficeBoschUrl}${id}`
    );
  }

  findById(id: number): Observable<BackofficeBoschDTO> {
    return this.http.get<BackofficeBoschDTO>(
      environment.apiUrl + `${this.backofficeBoschUrl}${id}`
    );
  }

  buildQueryForFilters(searchFormDTO: SearchFormDTO): string {
    let query = "";

    if (searchFormDTO.name) {
      query += `&name=${searchFormDTO.name}`;
    }
    if (searchFormDTO.userType) {
      query += `&userType=${searchFormDTO.userType}`;
    }

    return query;
  }

  findByFilters(
    searchFormDTO: SearchFormDTO
  ): Observable<BackofficeBoschDTO[]> {
    const query = this.buildQueryForFilters(searchFormDTO);

    return this.http.get<BackofficeBoschDTO[]>(
      environment.apiUrl + `${this.backofficeBoschUrl}filters?${query}`
    );
  }

  sendEmailByFilters(searchFormDTO: SearchFormDTO, emailDTO: EmailDTO) {
    const query = this.buildQueryForFilters(searchFormDTO);

    return this.http.post<any>(
      `${environment.apiUrl}${this.backofficeBoschUrl}email?${query}`,
      emailDTO
    );
  }

  edit(id: number, backofficeBoschDTO: BackofficeBoschDTO): Observable<any> {
    return this.http.put<any>(
      environment.apiUrl + `${this.backofficeBoschUrl}${id}`,
      backofficeBoschDTO
    );
  }

  associateClient(backofficeUserId: number, id: number) {
    const param = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.post<any>(
      environment.apiUrl +
        `${this.backofficeBoschUrl}${backofficeUserId}/clients/${id}`,
      { data: "data" },
      { headers: param }
    );
  }

  deleteClients(backofficeUserId: number, id: number) {
    return this.http.delete<any>(
      environment.apiUrl +
        `${this.backofficeBoschUrl}${backofficeUserId}/clients/${id}`
    );
  }

  getAllClients(backofficeUserId: number) {
    return this.http.get<any>(
      environment.apiUrl +
        `${this.backofficeBoschUrl}${backofficeUserId}/clients`
    );
  }

  findByClientAndName(clientId: number, name: string) {
    return this.http.get<any>(
      environment.apiUrl +
        `${this.backofficeBoschUrl}budget-analyst-autocomplete?clientId=${clientId}&name=${name}`
    );
  }

  getBackofficesByFranchiseId(
    franchiseId: number,
    pageManager: PageManager,
    sortField: string,
    sortDirection: string
  ): Observable<PaginatedResponse<BackofficeBoschDTO>> {
    let params = new HttpParams()
      .set("franchiseId", franchiseId.toString())
      .set("paginated", "true")
      .set("page", pageManager.pageIndex.toString())
      .set("size", pageManager.pageSize.toString());

    if (sortField && sortDirection) {
      params = params.set("sort", `${sortField},${sortDirection}`);
    }

    return this.http.get<PaginatedResponse<BackofficeBoschDTO>>(
      `${environment.apiUrl}${this.backofficeBoschUrl}filters`,
      { params }
    );
  }
}
